import { Directive, HostListener, input } from '@angular/core';


@Directive({
    selector: '[gaEvent]'
})
export class GaEventDirective {

    category = input.required<string>({ alias: 'gaEvent' });

    action = input.required<string>({ alias: 'gaAction' });

    label = input<string | undefined>(undefined, { alias: 'gaLabel' });

    value = input<number | undefined>(undefined, { alias: 'gaValue' });

    @HostListener('click')
    onClick() {
        if ((window as any).ga) {
            (window as any).ga('send', 'event', this.category(), this.action(), this.label(), this.value());
        }
    }
}
